import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { hasPerm, useAuthStore } from '@/store/auth';
/**
 * Permission-based route guard — Slice 3.
 *
 * Pairs with the perm-driven sidebar so that *the same key* gates both
 * "is the link visible?" and "can I open the page?". When you grant a
 * permission via /admin/rbac, the sidebar item appears AND the route
 * becomes openable in lockstep — no tier-vs-perm fights.
 *
 *   <PermGuard requiredPerm="clients.view">
 *     <ClientsPage />
 *   </PermGuard>
 */
export function PermGuard({ requiredPerm, children, fallback = '/access-denied' }) {
    const me = useAuthStore((s) => s.me);
    const location = useLocation();
    if (!me) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location.pathname } });
    }
    if (!hasPerm(me, requiredPerm)) {
        return (_jsx(Navigate, { to: fallback, replace: true, state: { from: location.pathname, requiredPerm } }));
    }
    return _jsx(_Fragment, { children: children });
}
